module.exports = __webpack_public_path__ + "static/media/most-popular-badge.9fbca9ae.svg";